export const addIntegrationValidationWarnings = {
  hasSelectedAreaOrSchoolNameOrSchoolDistrictField: 'You should select an Area, a School Name, or a School District!',
  urlWarning: (name: string) => `${name} must be a valid url!`,
  certificateSupportedFormatWarning: 'Only .p12 format is supported',
  validationGoogleDriveLinkWarning: 'You should enter a valid google drive link!',
  validationServiceEmailWarning: 'Service Email Address must be a valid email!',
  validationmMsterClassroomEmailAccountlWarning: 'User to impersonate must be a valid email!',
};
